export default "__VITE_ASSET__Bdi25oCA__"